import {
  XOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  FacebookOutlined,
} from "@ant-design/icons";
import React from "react";
import "../assets/scss/components/_footer.scss";
import { Col, Container, Row } from "reactstrap";
import { Footer as AntFooter } from "antd/es/layout/layout";
import { Link } from "react-router-dom";
import { Layout } from "antd";

const Footer = () => {
  return (
    <Layout>
      <footer className="footer">
        <AntFooter className="text-center leading-6 bg-[#F3F3FA]">
          Genç KOMEK {new Date().getFullYear()} © <br />
          <Link
            className="text-primary"
            target="_blank"
            to="https://sehirteknolojileri.com/"
            style={{ color: "#F7941C" }}
          >
            Şehir Teknolojileri Merkezi{" "}
          </Link>
          tarafından yapıldı.
        </AntFooter>
      </footer>
    </Layout>
  );
};

export default Footer;

const IconStyle = {};
